import { createFileRoute } from '@tanstack/react-router';
import Mods from 'src/pages/Organization/Event/Mods';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/mods/',
)({
  component: Mods,
});
